import { render, staticRenderFns } from "./PointTypeListView.vue?vue&type=template&id=b061757a&scoped=true"
import script from "./PointTypeListView.vue?vue&type=script&lang=js"
export * from "./PointTypeListView.vue?vue&type=script&lang=js"
import style0 from "./PointTypeListView.vue?vue&type=style&index=0&id=b061757a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b061757a",
  null
  
)

export default component.exports